(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nav-item-submenu"] && !Shopify.designMode) return;
  try {
    class NavDetails extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.onOutsidePointerDown = this.onOutsidePointerDown.bind(this);
      this.onEscapeKey = this.onEscapeKey.bind(this);
      this.close = this.close.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      const summary = this.details.querySelector('summary');
      this.subnav = summary?.nextElementSibling;
      this.closeBtn = this.querySelector('[details-close]');

      this.details.addEventListener('toggle', this.onToggle);
      if (summary) summary.addEventListener('click', this.onSummaryClick);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);

      if (this.details.hasAttribute('open')) {
        if (this.subnav) this.animateOpen();
        this.attachOpenListeners();
        this.syncSummaryExpanded();
      }
    }

    disconnectedCallback() {
      this.detachOpenListeners();
      this.clearCloseTimers();
      if (this.details) {
        this.details.removeEventListener('toggle', this.onToggle);
      }
      const summary = this.details?.querySelector('summary');
      if (summary) summary.removeEventListener('click', this.onSummaryClick);
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.close);
      if (this.subnav) this.subnav.removeEventListener('transitionend', this.onTransitionEnd);
    }

    onSummaryClick(event) {
      if (this.details.hasAttribute('open')) {
        event.preventDefault();
        this.close();
      }
    }

    attachOpenListeners() {
      document.removeEventListener('pointerdown', this.onOutsidePointerDown, true);
      document.addEventListener('pointerdown', this.onOutsidePointerDown, true);
      this.removeEventListener('keydown', this.onEscapeKey);
      this.addEventListener('keydown', this.onEscapeKey);
    }

    detachOpenListeners() {
      document.removeEventListener('pointerdown', this.onOutsidePointerDown, true);
      this.removeEventListener('keydown', this.onEscapeKey);
    }

    onOutsidePointerDown(event) {
      if (!this.details.hasAttribute('open')) return;
      if (this.contains(event.target)) return;
      this.close();
    }

    onEscapeKey(event) {
      if (event.key !== 'Escape') return;
      if (!this.details.hasAttribute('open')) return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    syncSummaryExpanded() {
      const summary = this.details?.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', this.details.hasAttribute('open') ? 'true' : 'false');
    }

    getSubnavTransitionMs() {
      if (!this.subnav) return 0;
      const raw = getComputedStyle(this.subnav).transitionDuration;
      if (!raw || raw === '0s' || raw === '0ms') return 0;
      return Math.max(
        0,
        ...raw.split(',').map((t) => {
          const s = t.trim();
          const n = parseFloat(s);
          if (Number.isNaN(n)) return 0;
          return s.endsWith('ms') ? n : n * 1000;
        })
      );
    }

    clearCloseTimers() {
      if (this._closeFallbackTimer != null) {
        clearTimeout(this._closeFallbackTimer);
        this._closeFallbackTimer = null;
      }
      if (this.subnav) this.subnav.removeEventListener('transitionend', this.onTransitionEnd);
    }

    finalizeClose() {
      this.clearCloseTimers();
      if (this.subnav) this.subnav.classList.remove('subnav--open', 'subnav--closing');
      const returnFocus = this.subnav?.contains(document.activeElement);
      if (this.details?.hasAttribute('open')) this.details.removeAttribute('open');
      this.syncSummaryExpanded();
      if (returnFocus) this.details?.querySelector('summary')?.focus();
    }

    onTransitionEnd(event) {
      if (event.target !== this.subnav) return;
      if (event.propertyName !== 'transform' && event.propertyName !== 'opacity') return;
      this.finalizeClose();
    }

    onToggle() {
      this.syncSummaryExpanded();
      if (this.details.hasAttribute('open')) {
        this.closeSiblings();
        if (this.subnav) this.animateOpen();
        this.attachOpenListeners();
      } else {
        this.detachOpenListeners();
        this.clearCloseTimers();
        if (this.subnav) this.subnav.classList.remove('subnav--open', 'subnav--closing');
      }
    }

    // Pointer users get this via onOutsidePointerDown; keyboard users opening
    // another menu with Enter/Space never trigger a pointerdown.
    closeSiblings() {
      const scope = this.closest('nav') || document;
      scope.querySelectorAll('nav-details').forEach((navDetails) => {
        if (navDetails !== this && navDetails.details?.hasAttribute('open')) navDetails.close();
      });
    }

    animateOpen() {
      if (!this.subnav) return;
      this.subnav.classList.remove('subnav--open', 'subnav--closing');
      // Double rAF: first frame commits the opacity-0 starting state painted by
      // the [open] CSS rule; second frame triggers the transition into subnav--open.
      // A single rAF (or offsetHeight alone) isn't reliable on first open because
      // the toggle event fires before the browser has committed a paint frame.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.subnav?.classList.add('subnav--open'));
      });
    }

    close() {
      if (!this.subnav) {
        this.details.removeAttribute('open');
        this.syncSummaryExpanded();
        return;
      }
      if (this.subnav.classList.contains('subnav--closing')) return;
      this.clearCloseTimers();
      this.subnav.classList.add('subnav--closing');
      this.subnav.addEventListener('transitionend', this.onTransitionEnd);
      const ms = this.getSubnavTransitionMs();
      this._closeFallbackTimer = window.setTimeout(() => this.finalizeClose(), ms + 80);
    }
  }

  customElements.define('nav-details', NavDetails);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["count-up"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('count-up')) {
    class CountUp extends HTMLElement {
      constructor() {
        super();

        this.start = parseInt(this.getAttribute('start')) || 0;
        this.duration = parseInt(this.getAttribute('duration')) || 2000;
        this.animated = false;
        this.animationFrame = null;
        this.observer = null;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      connectedCallback() {
        // Read target value from attribute or from element's text content
        // (textContent is only available after element is connected)
        const valueAttr = this.getAttribute('value');
        const textContent = this.textContent.trim();
        this.target = valueAttr ? parseInt(valueAttr, 10) : textContent ? parseInt(textContent, 10) : 0;

        // Validate target value
        if (isNaN(this.target)) {
          this.target = 0;
        }

        // Set accessibility attributes
        // aria-live="off" during animation to avoid announcing every number change
        // Will be set to "polite" when animation completes
        this.setAttribute('aria-live', 'off');
        this.setAttribute('aria-atomic', 'true');

        // Display initial value
        this.textContent = this.start;

        // If reduced motion is preferred, show final value immediately
        if (this.prefersReducedMotion) {
          this.textContent = this.target;
          this.setAttribute('aria-live', 'polite');
          return;
        }

        // Set up Intersection Observer to start animation when in view
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.animated) {
                this.startAnimation();
                this.observer.disconnect();
              }
            });
          },
          { threshold: 0.1 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        // Clean up observer and cancel animation
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }
      }

      startAnimation() {
        this.animated = true;
        const startTime = performance.now();
        const startValue = this.start;
        const difference = this.target - this.start;
        let lastValue = startValue;

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / this.duration, 1);

          // Apply easing function (cubic ease-out)
          const easedProgress = this.easeOutCubic(progress);

          // Calculate current value
          const currentValue = Math.floor(startValue + difference * easedProgress);

          // Only update DOM if value changed (reduces reflows)
          if (currentValue !== lastValue) {
            this.textContent = currentValue;
            lastValue = currentValue;
          }

          // Continue animation if not complete
          if (progress < 1) {
            this.animationFrame = requestAnimationFrame(animate);
          } else {
            // Ensure final value is set
            this.textContent = this.target;
            // Enable aria-live to announce final value to screen readers
            this.setAttribute('aria-live', 'polite');
          }
        };

        this.animationFrame = requestAnimationFrame(animate);
      }

      easeOutCubic(t) {
        // Optimized: avoid Math.pow for better performance
        const u = 1 - t;
        return 1 - u * u * u;
      }
    }

    customElements.define('count-up', CountUp);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-animation"] && !Shopify.designMode) return;
  try {
    class VideoAnimation {
    constructor(container) {
      this.container = container;
      this.video = container.querySelector('video');

      if (this.video) {
        this.init();
      }
    }

    init() {
      // Ensure video has all necessary attributes for autoplay
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');

      // Load video data for Safari compatibility
      this.video.load();

      // Create intersection observer to detect when video is in viewport
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo();
            } else {
              this.pauseVideo();
            }
          });
        },
        {
          threshold: 0.1, // Start playing when 10% visible
          rootMargin: '50px', // Start playing 50px before entering viewport
        }
      );

      this.observer.observe(this.container);

      // Create resize observer to handle layout changes
      this.resizeObserver = new ResizeObserver(() => {
        // Re-check visibility when container size changes
        if (this.video && this.isVideoReady()) {
          this.checkInitialVisibility();
        }
      });
      this.resizeObserver.observe(this.container);

      // Handle video events - Safari needs more data loaded
      this.video.addEventListener('loadedmetadata', () => {
        // Check if video is already in viewport on load
        this.checkInitialVisibility();
      });

      this.video.addEventListener('canplay', () => {
        // Additional check when video is ready to play
        this.checkInitialVisibility();
      });

      this.video.addEventListener('canplaythrough', () => {
        // Safari often needs canplaythrough event
        this.checkInitialVisibility();
      });

      // Handle video errors
      this.video.addEventListener('error', (e) => {
        console.error('Video error:', e);
        console.warn('Video failed to load');
      });
    }

    isVideoReady() {
      // Safari often needs HAVE_ENOUGH_DATA (4) or at least HAVE_FUTURE_DATA (3)
      // Check for readyState >= 3 for better Safari compatibility
      return this.video && this.video.readyState >= 3;
    }

    checkInitialVisibility() {
      // Check if the video is already visible in the viewport on page load
      const rect = this.container.getBoundingClientRect();
      const isVisible =
        rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;

      // Additional check: ensure the video element itself is visible
      const videoRect = this.video.getBoundingClientRect();
      const videoVisible =
        videoRect.width > 0 && videoRect.height > 0 && videoRect.top < window.innerHeight && videoRect.bottom > 0;

      if (isVisible && videoVisible && this.video.paused && this.isVideoReady()) {
        this.playVideo();
      }
    }

    playVideo() {
      if (!this.video || !this.isVideoReady()) {
        // If video isn't ready, wait for it to be ready
        if (this.video && this.video.readyState < 3) {
          const tryPlay = () => {
            if (this.isVideoReady()) {
              this.attemptPlay();
            } else {
              // Wait a bit and try again
              setTimeout(tryPlay, 100);
            }
          };
          tryPlay();
        }
        return;
      }

      this.attemptPlay();
    }

    attemptPlay() {
      // Ensure video is still muted (Safari requirement)
      if (!this.video.muted) {
        this.video.muted = true;
      }

      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video is playing
          })
          .catch((error) => {
            // Autoplay was prevented - this is expected on some browsers
            // Only log if it's not a NotAllowedError (which is expected)
            if (error.name !== 'NotAllowedError') {
              console.warn('Video autoplay failed:', error);
            }
          });
      }
    }

    pauseVideo() {
      if (this.video) {
        this.video.pause();
      }
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  // Initialize all video animations on the page
  document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('.video-animation');
    initializeAndCheckVisibleVideos(videoContainers);
  });

  // Handle dynamic content loading (if using AJAX)
  document.addEventListener('shopify:section:load', (event) => {
    const videoContainers = event.target.querySelectorAll('.video-animation');
    initializeAndCheckVisibleVideos(videoContainers);
  });

  // Reusable function to initialize video animations and check for already visible videos
  function initializeAndCheckVisibleVideos(videoContainers) {
    // Initialize all video animations
    videoContainers.forEach((container) => {
      new VideoAnimation(container);
    });

    // Check for videos already visible after delays to ensure Safari compatibility
    // Safari needs more time to load video data
    [100, 500, 1000].forEach((delay) => {
      setTimeout(() => {
        videoContainers.forEach((container, index) => {
          const video = container.querySelector('video');
          if (video && video.readyState >= 3) {
            // HAVE_FUTURE_DATA or better for Safari
            const rect = container.getBoundingClientRect();
            const isVisible =
              rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;

            if (isVisible && video.paused) {
              // Ensure muted for Safari
              if (!video.muted) {
                video.muted = true;
              }
              video.play().catch((error) => {
                // Only log if it's not a NotAllowedError (expected on some browsers)
                if (error.name !== 'NotAllowedError') {
                  console.warn(`Video ${index + 1} autoplay failed:`, error);
                }
              });
            }
          }
        });
      }, delay);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
